import { TableBodyCell } from '../../../../../MyTickets.styled';
import { StatusCellProps } from './StatusCell.types';
import { StatusBadge } from 'src/components/Tickets/common/StatusBadge/StatusBadge';
export const StatusCell = ({ status }: StatusCellProps) => {
  return (
    <TableBodyCell>
      <StatusBadge status={status} />
    </TableBodyCell>
  );
};
